import { Expose, plainToInstance } from "class-transformer";
import {
  IsDate,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsEnum,
} from "class-validator";
import { InstallLocation } from "./install-location.enum";

export class DesignProjectOnboardingStepProjectElement {
  public static from(input: any) {
    return plainToInstance(DesignProjectOnboardingStepProjectElement, input, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  designProjectOnboardingStepId!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  projectElementId!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  projectElementName!: string;

  @Expose()
  @IsOptional()
  @IsString()
  selectedPriceRange?: string | null;

  @Expose()
  @IsOptional()
  @IsEnum(InstallLocation, { each: true })
  installLocation?: InstallLocation[] | null;

  @Expose()
  @IsOptional()
  @IsString()
  notes?: string;

  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceHigh?: number | null;

  @Expose()
  @IsInt()
  priority!: number;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;
}
